import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import Table from 'react-bootstrap/Table';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Label } from 'recharts';
import {BarChart, Bar } from 'recharts';

import SPCalc from '../util/SPCalc';
import ApiUtils from '../util/ApiUtils';
import UIUtils from '../util/UIUtils';
import Utilities from "../util/Utilities";
import UINotes from "../util/UINotes";
import SPUtilities from "../util/SPUtilities";
import OasisUtils from '../oasis/OasisUtils';

import EventsInline from "../oasis/EventsInline";

import CurrentRewards from './CurrentRewards';

import BaseLineChart from '../reports/BaseLineChart';
import BaseBarChart from '../reports/BaseBarChart';

// import RewardComparison from '../reports/RewardComparison';

class AddressInline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      responsive: true,
      size: 10,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }
  // rewardComparison: allData["rewardComparison"],

  render() {
    return (
      <div>
        <Table striped bordered size="sm" >
        <tbody>
          <tr>
            <th>Alias: </th>
            <td> {this.props.addressDetails.alias}</td>
          </tr>
          <tr>
            <th>Address: </th>
            <td> {this.props.addressDetails.address}</td>
          </tr>
          <tr>
            <th>Richlist Rank: </th>
            <td> {this.props.addressDetails.ranking}</td>
          </tr>
          <tr>
            <th>Total Coins: </th>
            <td> {this.props.addressDetails.totalBalance}</td>
          </tr>
          <tr>
            <th>Total Not Staked: </th>
            <td> {this.props.addressDetails.addressBalance}</td>
          </tr>
          <tr>
            <th>Total Staked: </th>
            <td> {this.props.addressDetails.totalStake}</td>
          </tr>
          <tr>
            <th>Total Rewards: </th>
            <td> {this.props.addressDetails.totalRewards}</td>
          </tr>
          <tr>
            <th>Total in USD: </th>
            <td> N/A</td>
          </tr>
          <tr>
            <th>Total in BTC: </th>
            <td> N/A</td>
          </tr>
        </tbody>
        </Table>
        <p/><hr/>
        {this.props.delegations.length > 0 && this.renderDelegations()}
        <p/><hr/>
        {this.props.stakeHistory.length > 0 && this.renderStakeHistory()}
        <p/>
        {this.props.rewards.length > 0 && this.renderRewardsSection()}
        <p/>
        {this.props.events.length > 0 && this.renderEvents()}
      </div>
    );
  }

  renderStakeHistory() {
    return (<div>
        <p/>
        <h4 style={{align: "center"}}>Stake History Summary</h4>
        <BaseBarChart xAxis="Date" yAxis="Shares"
          showVerticalLabel={true} valueAttr="shares" showTotalLabel={false}
          data={this.props.stakeHistory} xAxisValueAttr="procDate" />
        <hr/>
    </div>);
  }

  renderRewardsSection() {
    return (<div>
        <p/>
        <h4 style={{align: "center"}}>Rewards Summary</h4>
        <BaseBarChart xAxis="Date" yAxis="Rewards"
          showVerticalLabel={true} valueAttr="rewards" showTotalLabel={false}
          data={this.props.rewards} xAxisValueAttr="procDate" />
        <hr/>
    </div>);
  }

/*
  {SPUtilities.addressLink(this.state.address)}&nbsp;&nbsp;&nbsp;
  {SPUtilities.rewardsLink(this.state.address)}&nbsp;&nbsp;&nbsp;
  <a href={"/delegate/" + this.state.address} class="black-a">Address Details</a>
  <hr/>
  {this.state.rewards.length > 0 && this.renderRewardsSection()}
  renderRewardsSection() {
    return (<div>
        <p/>
        <p style={{align: "center"}}><span><strong>Stake/Reward Summary</strong></span></p>
        <CurrentRewards rewards={this.state.rewards} />
    </div>);
  }


  static dateFormatter(value, row) {
      return SPUtilities.getDateTimeAsText(value);
  }
*/

  renderEvents() {
    return (
      <div>
        <p/>
        <h4 style={{align: "center"}}>Recent Events</h4>
        <EventsInline data={this.props.events} />
      </div>
    )
  }

  renderDelegations() {
      var columns = [
        {text: "#", dataField: "index", formatter: SPUtilities.indexFormatter, sort: true,  headerStyle: Utilities.width(5)},
        {text: "Validator", dataField: "entityName", formatter: OasisUtils.entityFormatter, sort: true,  headerStyle: Utilities.width(40)},
        {text: "Shares",dataField: "shares", formatter: SPUtilities.stakeFormatterRounded, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(25)},
        {text: "Staked Coins",dataField: "stake", formatter: SPUtilities.stakeFormatterRounded, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(25)},
      ];
      // {text: "Total USD",dataField: "stake", formatter: SPCalc.calcTotalUSD, formatExtraData: this, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
      // {text: "Total BTC",dataField: "stake", formatter: SPCalc.calcTotalBTC, formatExtraData: this, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},

      return (
        <div>
          <h4 style={{align: "center"}}>Delegation Breakdown</h4>
          <BootstrapTable keyField='address' data={ this.props.delegations }
            columns={ columns } striped hover condensed noDataIndication="No data"/>
        </div>
      );
  }

}

export default AddressInline;



// WEBPACK FOOTER //
// ./src/address/AddressInline.js